import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('toolbar',{attrs:{"mode":"export","title":"Generate","view":"list"}}),_c(VCard,{attrs:{"flat":""}},[_c('ExportForm',{attrs:{"predictions":_vm.predictions,"connections":_vm.connections,"techniques":_vm.techniques},on:{"submitted":_vm.onSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }